import clsx from "clsx";
import type { ComponentProps } from "react";

import { mod } from "@shared/utils";

import s from "./toggle.module.scss";

export type CompProps = ComponentProps<"div"> & {
  className?: string;
  isActive?: boolean;
  variant?: "default" | "white";
};

export const Toggle = (props: CompProps) => {
  const { className, isActive, variant } = props;

  const mods = mod(s, {
    variant,
  });

  return (
    <div className={clsx(s.root, className, mods, { [s.active]: isActive })}>
      <div />
    </div>
  );
};

Toggle.displayName = "Toggle";
